import { motion } from "framer-motion";
import { SERVICES } from "@/data/business";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] } }),
};

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="max-w-[1600px] mx-auto px-5 md:px-10 py-24 md:py-40">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16 md:mb-24">
        <div>
          <span className="text-xs uppercase tracking-[0.2em] text-[#FF3B30] font-mono-plex font-bold">
            [ 01 — What we fix ]
          </span>
          <h2 className="font-display font-bold uppercase tracking-tight text-white text-4xl md:text-6xl lg:text-7xl mt-6 leading-[0.9]">
            Every appliance,<br />under one roof.
          </h2>
        </div>
        <p className="text-[#A0A0A0] text-sm max-w-xs font-mono-plex leading-relaxed">
          From cooling to cleaning to entertainment — if it runs on power, we repair and install it.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 border-t border-l border-[#222222]">
        {SERVICES.map((s, i) => (
          <motion.div
            key={s.no}
            custom={i}
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            data-testid={`service-card-${s.no}`}
            className="group relative border-r border-b border-[#222222] p-8 md:p-12 hover:bg-[#0D0D0D] transition-colors duration-300 min-h-[280px] flex flex-col justify-between"
          >
            <span className="font-mono-plex text-[#333333] text-sm group-hover:text-[#FF3B30] transition-colors">
              /{s.no}
            </span>
            <div>
              <h3 className="font-display font-medium text-white text-2xl md:text-3xl mb-4 tracking-tight">
                {s.title}
              </h3>
              <p className="text-[#A0A0A0] text-sm font-mono-plex leading-relaxed">{s.desc}</p>
            </div>
            <span className="absolute top-8 right-8 w-2 h-2 bg-[#222222] group-hover:bg-[#FF3B30] transition-colors" />
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Services;
